// The asset families a single-seat subscription can cover.
export enum SingleSeatFamilyEnum {
  CREATIVE = 'creative',
  EDITORIAL = 'editorial',
}

// What the single-seat subscription offers this visitor in their market. A market that sells both
// families offers both members; one that sells none has an empty set.
export type SingleSeatOffer = Readonly<{
  families: ReadonlySet<SingleSeatFamilyEnum>;
}>;

const isSingleSeatFamily = (value: string): value is SingleSeatFamilyEnum =>
  Object.values<string>(SingleSeatFamilyEnum).includes(value);

export class SingleSeatOfferFactory {
  // Rails sends the families as one comma-joined string ('creative', 'editorial' or
  // 'creative,editorial'), or null when nothing is on offer. A family the enum does not know is
  // dropped, so it never reaches the rules posing as something the market sells.
  fromAvailableFamily = (availableFamily?: string | null): SingleSeatOffer => ({
    families: new Set(
      (availableFamily ?? '')
        .split(',')
        .map((family) => family.trim())
        .filter(isSingleSeatFamily)
    ),
  });
}
